// Copyright (C) 2021 Bystronic Laser AG

export enum TubesTab {
  Overview,
  IntradayAvailability,
  Trends,
}
